import { render, staticRenderFns } from "./AppelaUserDetail.vue?vue&type=template&id=dc99da30&scoped=true"
import script from "./AppelaUserDetail.vue?vue&type=script&lang=js"
export * from "./AppelaUserDetail.vue?vue&type=script&lang=js"
import style0 from "./AppelaUserDetail.vue?vue&type=style&index=0&id=dc99da30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc99da30",
  null
  
)

export default component.exports